import React from 'react';
import './utils/animation.scss';
import {
    Button,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Spinner,
} from 'reactstrap';
import ResourceComponent from '../../common/ResourceComponent';
import {checkboxFormatter, discountFormatter, dollarsFormatter, imageFormatter} from '../../common/TableFormatters';
import * as actions from './EmbeddableApi';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import {standardTableProps} from '../../common/BootstrapTools';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import ReCAPTCHA from 'react-google-recaptcha';
import {getGoogleCaptchaKey, getPublicUrl} from '../../common/AppContextTools';
import {PaymentElement} from '../stripe/StripeElements';
import SquareElement from '../square/SquareElement';
import moment from 'moment';
import './EmbSubmitModal.scss';
import {getMaterialImageAlt} from '../../common/Utils';
import _ from 'lodash';
import PhoneNumberInput from '../../common/form/PhoneNumberInput';
import {isPossiblePhoneNumber} from 'react-phone-number-input';

class EmbSubmitModal extends ResourceComponent {
    state = {
        resource: {
            first_name: '',
            last_name: '',
            email_address: '',
            address_1: '',
            address_2: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            phone: '',
            comments: '',
            quote: false,
            price: 0,
        },
        captcha: null,
        invalidCaptcha: false,
        claimedItems: [],
        to_surfacing: [],
        to_sanding: [],
        price: 0,
        totalPrice: 0,
        ordered: false,
        animation: false,
        isValidCard: false,
        stripePaymentMethod: '',
        squarePaymentMethod: '',
        paymentError: '',
        loading: false,
        order_id: null,
        isProcessing: true,
        stripeLoaded: false,
        salesTax: 0,
        taxesLoading: false,
        prevClaimedItems: [],
        isPhoneNumberValid: true,
    };

    constructor() {
        super();
        this.modalRef = React.createRef();
    }

    loadStripeScript = () => {
        if (!this.state.stripeLoaded) {
            const script = document.createElement('script');
            script.src = 'https://js.stripe.com/v3/';
            script.id = 'stripe-script';
            script.onload = () => {
                this.setState({stripeLoaded: true});
            };
            document.body.appendChild(script);
        }
    };

    componentDidMount() {
        const {claimedItems} = this.props;
        const price = this.calculateBasePrice(claimedItems);
        const totalPrice = this.calculateTotalPrice(claimedItems, price);
        this.props.sendEventData('begin_checkout', {
            currency: 'USD',
            value: totalPrice,
            items: claimedItems.map(i => ({
                item_name: i.name,
                price: i.price,
            })),
        });
        this.setState({claimedItems, price, totalPrice});
        this.scrollToTop();
    };

    scrollToTop = () => this.modalRef.current.scrollIntoView();

    componentDidUpdate(prevProps, prevState) {
        const {order_id, prevClaimedItems, ordered} = this.state;
        const {claimEnabled, ecommerceConnected, closeFn} = this.props;
        if (order_id && !_.isEqual(order_id, prevState.order_id)) {
            this.checkIfOrderIsCompleted(order_id);
        }
        if (!ordered && !claimEnabled && this.props.square_connect_status && ecommerceConnected) {
            if (!_.isEqual(this.props.claimedItems, prevClaimedItems)) {
                this.setState({prevClaimedItems: _.cloneDeep(this.props.claimedItems), taxesLoading: true});
                this.getItemsTaxes();
            }
        }
        if (!ordered && this.props.claimedItems.length === 0) {
            closeFn();
        }
    }

    getItemsTaxes = () => {
        const publicUrl = getPublicUrl();
        const {claimedItems} = this.props;
        const {totalPrice} = this.state;
        const data = {
            public_url: publicUrl,
            items: claimedItems.map(i => ({
                type: i.type,
                square_item_id: i.square_item_id,
                request_sanded: i.request_sanded,
                request_surfaced: i.request_surfaced,
            })),
        };
        this.props.actions.getItemsTaxes(data, res => {
                this.setState({taxesLoading: false, salesTax: res.total_tax, totalPrice: +totalPrice + +res.total_tax});
            },
        );
    };

    checkIfOrderIsCompleted = (orderId) => {
        const myInterval = setInterval(() => {
            this.props.actions.getOrderByTransactionId(orderId, order => {
                if (order.paid) {
                    const myTimeout = setTimeout(() => {
                        this.setState({isProcessing: false});
                        clearInterval(myInterval);
                        clearTimeout(myTimeout);
                    }, 1000);
                }
            });
        }, 2000);
    };

    claimSlabs = (resource) => {
        const {captcha, totalPrice, to_surfacing, to_sanding} = this.state;
        const {recaptcha, claimedItems} = this.props;

        const success = () => {
            const randomId = [...Array(6)].map(() => Math.random().toString(36)[2]).join('');
            this.props.sendEventData('purchase', {
                currency: 'USD',
                transaction_id: `Claim_${randomId}`,
                value: totalPrice,
                items: claimedItems.map(i => ({
                    item_name: i.inventory_number ? `Pack: ${i.inventory_number}` : `Slab: ${i.number}`,
                    price: i.price,
                })),
            });
            analytics.track('Order Complete', {
                client_id: this.props.client_id,
                client_name: this.props.client_name,
                quote: this.state.quote || false,
                paid: this.state.paid || false,
                price: totalPrice,
                zip: resource.zip,
                payment_platform: 'Claim',
                collected_fee: this.state.collected_fee,
                created_at: moment(),
                items: claimedItems.map(i => ({
                    type: i.type,
                    price: i.price,
                    total_bf: i.total_bf,
                    created_at: i.created_at,
                })),
            }, {groupId: this.props.profile.client_id});
            this.setState({
                activeTab: '2',
                animation: true,
                ordered: true,
                loading: false,
                isProcessing: false,
            }, this.scrollToTop);
            this.props.clearCart();
        };

        const error = (result) => {
            if (result.data.type === 'order') {
                this.setState({paymentError: result.data.message, loading: false});
            } else if (recaptcha) {
                this.captchaRef.current.reset();
                this.setState({invalidCaptcha: true, loading: false, captcha: null});
            }
        };

        if (captcha || !recaptcha) {
            resource.slab_ids = claimedItems.filter(i => i.type === 'Slab').map(s => s.id);
            resource.lumber_ids = claimedItems.filter(i => i.type === 'Lumber').map(s => s.id);
            resource.bundle_ids = claimedItems.filter(i => i.type === 'Pack').map(b => b.id);
            resource.industrial_pack_ids = claimedItems.filter(i => i.type === 'Industrial Pack').map(p => p.id);
            const params = {
                captcha, to_sanding, to_surfacing,
                price: totalPrice,
            };
            resource = {...resource, price: totalPrice};
            this.props.actions.createOrder(resource, params, success, error);
        } else {
            this.setState({invalidCaptcha: true});
        }
    };

    onTableCheck = (cell, row, fieldName) => {
        const {claimedItems} = this.state;
        const updatedClaimedItems = claimedItems.map(item => {
            if (item.id === row.id) {
                return {
                    ...item,
                    [`request_${fieldName}`]: !item[`request_${fieldName}`],
                };
            }
            return item;
        });
        const price = this.calculateBasePrice(updatedClaimedItems);
        this.props.actions.updateClaimedItems(updatedClaimedItems);
        this.setState({
            claimedItems: updatedClaimedItems,
            price,
            totalPrice: this.calculateTotalPrice(updatedClaimedItems, price),
        });
    };

    calculateBasePrice = (slabs) => {
        if (slabs.length > 0) {
            return slabs.length > 1 ? slabs.reduce((a, b) => (a.price ? +a.price : +a) + (+b.price)) : +slabs[0].price;
        } else return 0;
    };

    calculateTotalPrice = (items, basePrice) => {
        if (items.length > 0) {
            let i = 0;
            items.forEach(item => {
                if (item.request_sanded && item.sanding_cost_with_fee) {
                    i += +item.sanding_cost_with_fee;
                }
                if (item.request_surfaced && item.surfacing_cost_with_fee) {
                    i += +item.surfacing_cost_with_fee;
                }
            });
            return +basePrice + i;
        } else return 0;
    };

    updateServicesCollections = (id, sand = false) => {
        const update = (collection) => {
            const item = collection.find(i => i === id);
            if (item) {
                collection = collection.filter(i => i !== id);
            } else {
                collection.push(id);
            }
            return collection;
        };

        if (sand) {
            let collection = this.state.to_sanding;
            this.setState({to_sanding: update(collection)});
        } else {
            let collection = this.state.to_surfacing;
            this.setState({to_surfacing: update(collection)});
        }
    };

    removeItem = (item) => {
        this.props.actions.removeClaimedItem(item.id);
        let {claimedItems} = this.state;
        const slab = claimedItems.find(s => s.id === item.id);
        slab.request_sanded = undefined;
        slab.request_surfaced = undefined;

        claimedItems = claimedItems.filter(s => s.id !== item.id);
        const price = this.calculateBasePrice(claimedItems);
        this.setState({
            claimedItems,
            price,
            totalPrice: this.calculateTotalPrice(claimedItems, price),
        });
    };

    buyItems = (resource) => {
        this.captchaRef = React.createRef();
        const {captcha, to_sanding, to_surfacing, claimedItems, stripePaymentMethod, totalPrice} = this.state;
        const {recaptcha} = this.props;
        const success = () => {
            this.props.sendEventData('purchase', {
                currency: 'USD',
                transaction_id: this.state.order_id,
                value: totalPrice,
                items: claimedItems.map(i => ({
                    item_name: i.inventory_number ? `Pack: ${i.inventory_number}` : `Slab: ${i.number}`,
                    price: i.price,
                })),
            });
            analytics.track('Order Complete', {
                client_id: this.props.client_id,
                client_name: this.props.client_name,
                quote: this.state.quote || false,
                paid: this.state.paid || false,
                price: totalPrice,
                zip: resource.zip,
                payment_platform: this.state.payment_platform,
                collected_fee: this.state.collected_fee,
                created_at: moment(),
                items: claimedItems.map(i => ({
                    type: i.type,
                    price: i.price,
                    total_bf: i.total_bf,
                    created_at: i.created_at,
                })),
            }, {groupId: this.props.profile.client_id});
            this.setState({activeTab: '2', animation: true, ordered: true, loading: false}, this.scrollToTop);
            this.props.clearCart();
            this.props.search();
        };
        const error = (result) => {
            if (result.data.type === 'order') {
                this.setState({paymentError: result.data.message, loading: false});
            } else if (recaptcha) {
                this.captchaRef.current.reset();
                this.setState({invalidCaptcha: true, loading: false, captcha: null});
            }
        };
        if (captcha || !recaptcha) {
            resource.slab_ids = claimedItems.filter(i => i.type === 'Slab').map(s => s.id);
            resource.bundle_ids = claimedItems.filter(i => i.type === 'Pack').map(b => b.id);
            resource.lumber_ids = claimedItems.filter(i => i.type === 'Lumber').map(s => s.id);
            resource.industrial_pack_ids = claimedItems.filter(i => i.type === 'Industrial Pack').map(p => p.id);
            const params = {captcha, to_sanding, to_surfacing};
            this.setState({loading: true});
            let items = claimedItems.map(i => {
                return {
                    id: i.id,
                    discount: i.discount,
                    price: +i.price_no_discount,
                    price_no_fee: +i.price_no_fee,
                    request_sanded: i.request_sanded,
                    sanding_cost: +i.sanding_cost,
                    request_surfaced: i.request_surfaced,
                    surfacing_cost: +i.surfacing_cost,
                    type: i.type,
                };
            });
            if (this.props.stripe_connect_status) {
                this.props.actions.payByStripe(this.props.client_id, this.state.stripePaymentMethod, items, this.state.totalPrice, res => {
                    if (res.payment_status) {
                        resource = {
                            ...resource,
                            paid: res.payment_status,
                            collected_fee: res.collected_fee,
                            receipt_url: res.receipt_url,
                            order_id: res.order_id,
                            payment_platform: res.payment_platform,
                            price: this.state.totalPrice,
                        };
                        this.setState({
                            paid: res.payment_status,
                            payment_platform: res.payment_platform,
                            collected_fee: res.collected_fee,
                            order_id: res.order_id,
                        }, () => this.props.actions.createOrder(resource, params, success, error));
                    } else {
                        this.setState({paymentError: res.error, loading: false});
                    }
                });
            } else if (this.props.square_connect_status) {
                this.props.actions.payBySquare(this.props.client_id, this.state.squarePaymentMethod, items, resource, res => {
                    if (res.payment_status) {
                        this.setState({
                            paid: res.payment_status,
                            collected_fee: res.collected_fee,
                            payment_platform: 'Square',
                            order_id: res.order_id,
                        }, () => success());
                    } else {
                        this.setState({paymentError: res.error, loading: false});
                    }
                });
            }

        } else {
            this.setState({invalidCaptcha: true});
        }

    };

    isValidAmount = () => {
        const {totalPrice} = this.state;
        const {stripe_connect_status, square_connect_status, ecommerceConnected, claimEnabled} = this.props;
        if (square_connect_status && !claimEnabled) {
            return ecommerceConnected && totalPrice < 50000;
        } else if (stripe_connect_status && !claimEnabled) {
            return ecommerceConnected && totalPrice < 1000000;
        } else {
            return true;
        }
    };

    isUSA = () => {
        return this.props.profile.country === 'United States';
    };

    render() {
        this.captchaRef = React.createRef();
        const {
            claimedItems,
            resource,
            animation,
            price,
            invalidCaptcha,
            totalPrice,
            salesTax,
            taxesLoading,
            isPhoneNumberValid
        } = this.state;
        const {
            closeFn,
            card_detail,
            bundle_card_detail,
            lumber_card_detail,
            recaptcha,
            shipping,
            ecommerceConnected,
            claimEnabled,
        } = this.props;

        return (
            <div ref={this.modalRef}>
                <Container className='embed-submit-modal'>
                    {!this.state.ordered &&
                        <React.Fragment>
                            <ModalHeader>
                                <Row>
                                    <Col>
                                        Please complete your order.
                                    </Col>
                                    <Col>
                                        <FontAwesomeIcon
                                            className='float-right pointer' size='2x' icon={faTimes}
                                            onClick={closeFn} />
                                    </Col>
                                </Row>
                            </ModalHeader>
                            <Form
                                onSubmit={(e) => ecommerceConnected ? this.onSubmit(e, resource => this.buyItems(resource)) : this.onSubmit(e, resource => this.claimSlabs(resource))}>
                                <div className={'mt-3'}>
                                    <FormGroup row className='mt-3'>
                                        <Col sm={2}>
                                            <Label>
                                                First name*
                                            </Label>
                                        </Col>
                                        <Col sm={8}>
                                            <Input
                                                invalid={this.validationState('first_name', this.requiredValidator)}
                                                type='text'
                                                placeholder='first name'
                                                value={resource.first_name}
                                                onChange={this.onTextChange('first_name')}
                                            />
                                        </Col>
                                        <Col sm={2} />
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col sm={2}>
                                            <Label>
                                                Last name*
                                            </Label>
                                        </Col>
                                        <Col sm={8}>
                                            <Input
                                                invalid={this.validationState('last_name', this.requiredValidator)}
                                                type='text'
                                                placeholder='last name'
                                                value={resource.last_name}
                                                onChange={this.onTextChange('last_name')}
                                            />
                                        </Col>
                                        <Col sm={2} />
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col sm={2}>
                                            <Label>
                                                Email*
                                            </Label>
                                        </Col>
                                        <Col sm={8}>
                                            <Input
                                                invalid={this.validationState('email_address', this.requiredValidator)}
                                                type='email'
                                                placeholder='email'
                                                value={resource.email_address}
                                                onChange={this.onTextChange('email_address')}
                                            />
                                        </Col>
                                        <Col sm={2} />
                                    </FormGroup>
                                    {!claimEnabled && <React.Fragment>
                                        <FormGroup row>
                                            <Col sm={2}>
                                                <Label>
                                                    Address 1*
                                                </Label>
                                            </Col>
                                            <Col sm={8}>
                                                <Input
                                                    invalid={this.validationState('address_1', this.requiredValidator)}
                                                    type='text'
                                                    placeholder='address 1'
                                                    value={resource.address_1}
                                                    onChange={this.onTextChange('address_1')}
                                                />
                                            </Col>
                                            <Col sm={2} />
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col sm={2}>
                                                <Label>
                                                    Address 2
                                                </Label>
                                            </Col>
                                            <Col sm={8}>
                                                <Input
                                                    type='text'
                                                    placeholder='address 2'
                                                    value={resource.address_2}
                                                    onChange={this.onTextChange('address_2')}
                                                />
                                            </Col>
                                            <Col sm={2} />
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col sm={2}>
                                                <Label>
                                                    City*
                                                </Label>
                                            </Col>
                                            <Col sm={8}>
                                                <Input
                                                    invalid={this.validationState('city', this.requiredValidator)}
                                                    type='text'
                                                    placeholder='city'
                                                    value={resource.city}
                                                    onChange={this.onTextChange('city')}
                                                />
                                            </Col>
                                            <Col sm={2} />
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col sm={2}>
                                                <Label>
                                                    {this.isUSA() ? 'State*' : 'Province*'}
                                                </Label>
                                            </Col>
                                            <Col sm={8}>
                                                <Input
                                                    invalid={this.validationState('state', this.requiredValidator)}
                                                    type='text'
                                                    placeholder={this.isUSA() ? 'state' : 'province'}
                                                    value={resource.state}
                                                    onChange={this.onTextChange('state')}
                                                />
                                            </Col>
                                            <Col sm={2} />
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col sm={2}>
                                                <Label>
                                                    {this.isUSA() ? 'Zip*' : 'Postal Code*'}
                                                </Label>
                                            </Col>
                                            <Col sm={8}>
                                                <Input
                                                    invalid={this.validationState('zip', this.requiredValidator)}
                                                    type='text'
                                                    placeholder={this.isUSA() ? 'zip' : 'postal code'}
                                                    value={resource.zip}
                                                    onChange={this.onTextChange('zip')}
                                                />
                                            </Col>
                                            <Col sm={2} />
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col sm={2}>
                                                <Label>
                                                    Country*
                                                </Label>
                                            </Col>
                                            <Col sm={8}>
                                                <Input
                                                    invalid={this.validationState('country', this.requiredValidator)}
                                                    type='text'
                                                    placeholder='country'
                                                    value={resource.country}
                                                    onChange={this.onTextChange('country')}
                                                />
                                            </Col>
                                            <Col sm={2} />
                                        </FormGroup>
                                    </React.Fragment>}
                                    <FormGroup row>
                                        <Col sm={2}>
                                            <Label>
                                                Phone
                                            </Label>
                                        </Col>
                                        <Col sm={8}>
                                            <PhoneNumberInput
                                                value={resource.phone}
                                                invalid={resource.phone.length > 0 && !isPhoneNumberValid && this.state.submitted}
                                                onChange={(value) => {
                                                    this.setState({resource: {...resource, phone: value}});
                                                    this.setState({isPhoneNumberValid: isPossiblePhoneNumber(value)});
                                                }}
                                            />
                                        </Col>
                                        <Col sm={2} />
                                    </FormGroup>
                                </div>
                                <FormGroup row>
                                    <Col className='pl-4'>
                                        <Label>
                                            I'm interested in the following items:
                                        </Label>
                                    </Col>
                                </FormGroup>
                                <FormGroup row className='pl-3 pr-3'>
                                    <BootstrapTable
                                        classes='inline'
                                        {...standardTableProps}
                                        bordered
                                        data={claimedItems}
                                        keyField='id'
                                        columns={this.responsiveColumns(
                                            [
                                                {
                                                    dataField: 'picture',
                                                    text: 'Item Photo',
                                                    formatter: (image, item) => image ? imageFormatter(image.thumbnail_url, getMaterialImageAlt(item, image)) : null,
                                                },
                                                {
                                                    dataField: 'type',
                                                    text: 'Item Type',
                                                },
                                                {
                                                    dataField: 'number',
                                                    text: 'Item Number',
                                                },
                                                {
                                                    dataField: 'surfaced',
                                                    text: 'Request Surfacing',
                                                    formatter: (cell, row) => ((card_detail.surfaced && row.type === 'Slab') || (bundle_card_detail.surfaced && ['Pack', 'Industrial Pack'].includes(row.type)) || (lumber_card_detail.surfaced && ['Lumber'].includes(row.type))) ? checkboxFormatter(cell, row, 'surfaced',
                                                        () => {
                                                            this.updateServicesCollections(row.id);
                                                            this.onTableCheck(cell, row, 'surfaced');
                                                        }) : null,
                                                },
                                                {
                                                    dataField: 'sanded',
                                                    text: 'Request Sanding',
                                                    formatter: (cell, row) => ((card_detail.sanded && row.type === 'Slab') || (bundle_card_detail.sanded && ['Pack', 'Industrial Pack'].includes(row.type)) || (lumber_card_detail.sanded && ['Lumber'].includes(row.type))) ? checkboxFormatter(cell, row, 'sanded',
                                                        () => {
                                                            this.updateServicesCollections(row.id, true);
                                                            this.onTableCheck(cell, row, 'sanded');
                                                        }) : null,
                                                },
                                                {
                                                    dataField: 'price',
                                                    text: 'Price',
                                                    formatter: (cell, row) => discountFormatter(cell, row.price_no_discount),
                                                },
                                                {
                                                    dataField: 'id',
                                                    text: 'Remove',
                                                    formatter: (_, row) => (
                                                        <div>
                                                            <FontAwesomeIcon
                                                                className='pointer' size='1x' icon={faTimes}
                                                                onClick={() => {
                                                                    this.props.sendEventData('remove_from_cart', {
                                                                        currency: 'USD',
                                                                        value: row.price,
                                                                        items: [{
                                                                            item_name: row.inventory_number ? `Pack: ${row.inventory_number}` : `Slab: ${row.number}`,
                                                                            price: row.price,
                                                                        }],
                                                                    });
                                                                    this.removeItem(row);
                                                                }} />
                                                        </div>
                                                    ),
                                                },
                                            ], 'Slabs')}
                                    />
                                </FormGroup>
                                <div className={taxesLoading ? 'tax-loading' : ''}>
                                    <FormGroup row>
                                        <Col>
                                            <span className='float-right'>Additions:</span>
                                        </Col>
                                        <Col>
                                            {claimedItems.filter(x => x.request_sanded || x.request_surfaced).map(i =>
                                                <div key={Math.random()}>
                                                    {i.number}  &nbsp;
                                                    {i.request_sanded ?
                                                        <span><b> {dollarsFormatter(i.sanding_cost_with_fee)}</b> (sanding) </span> : null}
                                                    {i.request_surfaced ?
                                                        <span><b> {dollarsFormatter(i.surfacing_cost_with_fee)}</b> (surfacing) </span> : null}
                                                </div>,
                                            )}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col>
                                            <span className='float-right'>Base:</span>
                                        </Col>
                                        <Col>
                                            <span className='h5 '>{dollarsFormatter(price)}</span>
                                        </Col>
                                    </FormGroup>
                                    {salesTax > 0 &&
                                        <FormGroup row>
                                            <Col>
                                                <span className='float-right'>Sales Tax:</span>
                                            </Col>
                                            <Col>
                                            <span
                                                className='h5 border-top'>{!taxesLoading && dollarsFormatter(+salesTax)}</span>
                                            </Col>
                                        </FormGroup>
                                    }
                                    {(price !== totalPrice) &&
                                        <FormGroup row>
                                            <Col>
                                                <span className='float-right'>Total:</span>
                                            </Col>
                                            <Col>
                                            <span
                                                className='h4 border-top'>{!taxesLoading && dollarsFormatter(totalPrice)}</span>
                                            </Col>
                                        </FormGroup>
                                    }</div>
                                {shipping &&
                                    <FormGroup row tag='fieldset'>
                                        <Label className='text-center'>Will you need a quote for shipping?</Label>
                                        <FormGroup row>
                                            <Col>
                                                <FormGroup check className='float-right'>
                                                    <Label check>
                                                        <Input
                                                            onClick={() => this.setState({
                                                                resource: {
                                                                    ...resource,
                                                                    quote: true,
                                                                },
                                                            })}
                                                            type='radio'
                                                            name='radio1' />
                                                        {' '}Yes
                                                    </Label>
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input
                                                            onClick={() => this.setState({
                                                                resource: {
                                                                    ...resource,
                                                                    quote: false,
                                                                },
                                                            })}
                                                            type='radio'
                                                            name='radio1' />
                                                        {' '}No
                                                    </Label>
                                                </FormGroup>
                                            </Col>
                                        </FormGroup>
                                    </FormGroup>
                                }
                                {!claimEnabled && this.props.stripe_connect_status && ecommerceConnected &&
                                    <FormGroup row>
                                        {!this.state.stripeLoaded && this.loadStripeScript()}
                                        {this.state.stripeLoaded && <PaymentElement
                                            apiKey={this.props.stripe_api_key}
                                            setIsValidCard={(isValidCard) => this.setState({isValidCard})}
                                            setStripePaymentMethod={(stripePaymentMethod) => this.setState({stripePaymentMethod})}
                                        />}
                                    </FormGroup>}
                                {!claimEnabled && this.props.square_connect_status && ecommerceConnected &&
                                    <FormGroup row>
                                        <SquareElement square_application_id={this.props.square_application_id}
                                                       square_location_id={this.props.square_location_id}
                                                       sandbox={this.props.sandbox}
                                                       setIsValidCard={(isValidCard) => this.setState({isValidCard})}
                                                       setSquarePaymentMethod={(squarePaymentMethod) => this.setState({squarePaymentMethod})}
                                        />
                                    </FormGroup>}
                                {this.state.paymentError && <FormGroup row>
                                    <Col className='text-center'>
                                        <Label className='text-danger'>
                                            {this.state.paymentError}
                                        </Label>
                                    </Col>
                                </FormGroup>}
                                {!this.isValidAmount() && <FormGroup row>
                                    <Col className='text-center'>
                                        <Label className='text-danger'>
                                            Maximum payment amount
                                            is {this.props.square_connect_status ? '$50,000' : '$1,000,000'}. Please
                                            adjust
                                            and try again.
                                        </Label>
                                    </Col>
                                </FormGroup>}
                                <FormGroup row>
                                    <Col className='text-center'>
                                        <Label>
                                            Please list any questions or additional requests:
                                        </Label>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col className='text-center'>
                                        <Input
                                            type='textarea'
                                            placeholder='comments'
                                            value={resource.comments}
                                            onChange={this.onTextChange('comments')}
                                        />
                                    </Col>
                                </FormGroup>
                                {recaptcha &&
                                    <FormGroup row>
                                        <Col className='d-flex justify-content-center'>
                                            <ReCAPTCHA
                                                size='normal'
                                                sitekey={getGoogleCaptchaKey()}
                                                ref={this.captchaRef}
                                                onChange={value => this.setState({
                                                    captcha: value,
                                                    invalidCaptcha: false,
                                                })}
                                            />
                                        </Col>
                                    </FormGroup>
                                }
                                {invalidCaptcha &&
                                    <FormGroup row>
                                        <div className='m-auto text-danger'>
                                            Something went wrong. Try do captcha again.
                                        </div>
                                    </FormGroup>
                                }
                                <ModalFooter>
                                    <FormGroup row>
                                        <Col className='float-right'>
                                            {this.state.loading ? <React.Fragment>
                                                <Button className='mr-1' color='primary' type='submit'>
                                                    <Spinner size='lg' animation='border' role='status' />
                                                    <span>Payment processing...</span>
                                                </Button>
                                            </React.Fragment> : <React.Fragment>
                                                <Button
                                                    className='mr-1' color='primary' type='submit'
                                                    disabled={(ecommerceConnected && !this.state.isValidCard) || !this.isValidAmount()}
                                                >
                                                    Complete Purchase
                                                </Button>
                                                <Button color='danger' onClick={closeFn}>
                                                    Cancel
                                                </Button>
                                            </React.Fragment>}
                                        </Col>
                                    </FormGroup>
                                </ModalFooter>
                            </Form>
                        </React.Fragment>
                    }
                    {this.state.ordered &&
                        <React.Fragment>
                            <ModalHeader>
                                {this.props.ordered_message
                                    ? this.props.ordered_message
                                    : `Great! You have ordered ${claimedItems.length} items for $${+totalPrice.toFixed(2)}`
                                }
                                {!this.state.isProcessing && <Col>
                                    <FontAwesomeIcon
                                        className='float-right pointer' size='2x' icon={faTimes} onClick={() => {
                                        closeFn();
                                        this.setState({isProcessing: true});
                                    }} />
                                </Col>}
                            </ModalHeader>
                            <ModalBody>
                                {this.state.isProcessing &&
                                    <div
                                        className='d-flex flex-row-reverse justify-content-center align-items-center w-100 text-center'>
                                        <Spinner size='lg' animation='border' role='status' />
                                        <span className='mr-4'>Order is processing...</span>
                                    </div>}
                                {animation && !this.state.isProcessing ?
                                    <Row className='justify-content-center mt-5'>
                                        <Col>
                                            <Row className='text-center'>
                                                <Col>
                                                    <div className='success-checkmark'>
                                                        <div className='check-icon'>
                                                            <span className='icon-line line-tip' />
                                                            <span className='icon-line line-long' />
                                                            <div className='icon-circle' />
                                                            <div className='icon-fix' />
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className='text-center'>
                                                <Col>
                                          <span className='text-success mt-4 mb-4'>
                                                {ecommerceConnected ? 'Order completed!' : 'Slab claimed!'}
                                          </span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    : <div style={{height: 200}}></div>
                                }
                            </ModalBody>
                        </React.Fragment>
                    }
                </Container>
            </div>
        );
    }
}

EmbSubmitModal.propTypes = {
    claimedItems: PropTypes.array,
    closeFn: PropTypes.func,
    clearCart: PropTypes.func,
    actions: PropTypes.object,
    ordered_message: PropTypes.string,
};

const mapStateToProps = ({appState}) => ({
    profile: appState.profile,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EmbSubmitModal);


// WEBPACK FOOTER //
// ./src/containers/embeddable/EmbSubmitModal.js